/* Frounder v3 — product page behaviour (one instance per .frp root) */
(function(){
function init(root){
  if (!root || root.dataset.frpInit) return; root.dataset.frpInit = '1';
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function(s,r){ return (r||root).querySelector(s); };
  var $$ = function(s,r){ return Array.prototype.slice.call((r||root).querySelectorAll(s)); };
  var MONEY = root.dataset.money || '$' + '{' + '{amount}}';
  function money(cents){
    var n = (cents/100).toFixed(2).split('.'); n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY.replace(/\{\{\s*amount[^}]*\}\}/, n.join('.')).replace(/<[^>]+>/g,'');
  }
  var nice = function(s){ return String(s == null ? '' : s).replace(/''|"/g, ' in'); };
  var variants = JSON.parse(root.querySelector('script[data-frp="variants"]').textContent);
  var media    = JSON.parse(root.querySelector('script[data-frp="media"]').textContent);

  /* load sequence */
  function go(){ root.classList.add('loaded'); }
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(go); setTimeout(go, 900); } else { setTimeout(go, 200); }

  /* studio shot or photograph? sample the corners once the image is in */
  function classify(img, targets, lim){
    lim = lim || 225;
    try {
      var c = document.createElement('canvas'); c.width = c.height = 24;
      var x = c.getContext('2d', {willReadFrequently:true}); x.drawImage(img, 0, 0, 24, 24);
      var d = x.getImageData(0,0,24,24).data, pts = [[1,1],[22,1],[1,22],[22,22],[12,1],[1,12],[22,12],[12,22]], light = 0;
      pts.forEach(function(p){ var k = (p[1]*24+p[0])*4; if (Math.min(d[k], d[k+1], d[k+2]) > lim) light++; });
      var pk = light >= 6; /* a white studio ground with at most two edge samples on the subject */
      targets.forEach(function(t){ t.classList.remove('pk','cover'); t.classList.add(pk ? 'pk' : 'cover'); });
    } catch(e){ /* cross-origin without CORS — leave as contain, no blend */ }
  }
  $$('.frp-frame').forEach(function(f){
    var img = f.querySelector('img'), thumb = $('.frp-thumb[data-i="'+f.dataset.i+'"]');
    var ok = function(){ f.classList.add('ready'); classify(img, thumb ? [f, thumb] : [f]); };
    if (img.complete && img.naturalWidth) ok(); else { img.addEventListener('load', ok, {once:true}); img.addEventListener('error', function(){ f.classList.add('ready'); }, {once:true}); }
  });
  $$('.frp-plate img').forEach(function(img){
    var ok = function(){ classify(img, [img.parentElement], 205); };
    if (img.complete && img.naturalWidth) ok(); else img.addEventListener('load', ok, {once:true});
  });

  /* deferred frames: swap data-src in once the page has loaded, so the first photo is the only LCP candidate */
  function hydrate(f){ var img = f && f.querySelector('img[data-src]'); if (!img) return; if (img.dataset.srcset) img.srcset = img.dataset.srcset; img.src = img.dataset.src; img.removeAttribute('data-src'); img.removeAttribute('data-srcset'); }
  function hydrateAll(){ $$('.frp-frame').forEach(hydrate); }
  if (document.readyState === 'complete') setTimeout(hydrateAll, 300); else addEventListener('load', function(){ setTimeout(hydrateAll, 300); });

  /* stage */
  var framesEl = $('#frpFrames'), frames = $$('.frp-frame'), thumbs = $$('.frp-thumb'), cap = $('#frpCap'), now = $('#frpNow');
  var cur = 0, lockUntil = 0;
  function show(i, why){
    if (!frames.length) return;
    i = (i + frames.length) % frames.length;
    if (i === cur) return;
    hydrate(frames[i]); frames[cur].classList.remove('on'); frames[i].classList.add('on');
    thumbs.forEach(function(t,k){ t.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
    cur = i; now.textContent = ('0' + (i+1)).slice(-2);
    cap.classList.remove('on'); setTimeout(function(){ cap.textContent = frames[i].dataset.cap; cap.classList.add('on'); }, RM ? 0 : 180);
    if (why === 'user') lockUntil = Date.now() + 5000;
    syncMono();
  }
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ show(+t.dataset.i, 'user'); }); });
  if ('IntersectionObserver' in window && innerWidth > 1000) {
    var so = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting && Date.now() > lockUntil) show(Math.min(+e.target.dataset.shot, frames.length-1), 'scroll'); });
    }, {rootMargin:'-42% 0px -42% 0px', threshold:0});
    $$('.frp-rail [data-shot]').forEach(function(n){ so.observe(n); });
  }
  $('#frpStage').addEventListener('keydown', function(e){
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault(); var d = e.key === 'ArrowRight' ? 1 : -1;
    goTo(cur + d);
  });
  var dots = $$('#frpDots .frp-dot');
  function frameStep(){ return frames.length ? framesEl.scrollWidth / frames.length : framesEl.clientWidth; }
  function goTo(i, smooth){
    i = Math.max(0, Math.min(frames.length - 1, i));
    if (innerWidth > 1000) { show(i, 'user'); return; }
    hydrate(frames[i]);
    framesEl.scrollTo({left: frameStep() * i, behavior: (smooth === false || RM) ? 'auto' : 'smooth'});
  }
  framesEl.addEventListener('scroll', function(){
    if (innerWidth > 1000) return;
    var i = Math.min(frames.length - 1, Math.round(framesEl.scrollLeft / frameStep()));
    now.textContent = ('0' + (i+1)).slice(-2);
    dots.forEach(function(d,k){ d.classList.toggle('on', k === i); });
    hydrate(frames[i]); if (frames[i+1]) hydrate(frames[i+1]);
    if (i !== cur) { cur = i; syncMono(); }
  }, {passive:true});
  dots.forEach(function(d){ d.addEventListener('click', function(){ goTo(+d.dataset.i); }); });
  var prevBtn = $('#frpPrev'), nextBtn = $('#frpNext');
  if (prevBtn) prevBtn.addEventListener('click', function(){ goTo(cur - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function(){ goTo(cur + 1); });
  /* mouse drag on the rail (touch already swipes natively) */
  var drag = null;
  framesEl.addEventListener('pointerdown', function(e){
    if (innerWidth > 1000 || e.pointerType !== 'mouse' || e.button !== 0) return;
    drag = {x: e.clientX, left: framesEl.scrollLeft, moved: false}; framesEl.classList.add('dragging');
    try { framesEl.setPointerCapture(e.pointerId); } catch(err){}
  });
  framesEl.addEventListener('pointermove', function(e){
    if (!drag) return;
    var dx = e.clientX - drag.x; if (Math.abs(dx) > 4) drag.moved = true;
    framesEl.scrollLeft = drag.left - dx;
  });
  function endDrag(e){
    if (!drag) return;
    var moved = drag.moved, dx = e && e.clientX !== undefined ? e.clientX - drag.x : 0; drag = null;
    framesEl.classList.remove('dragging');
    var i = Math.round(framesEl.scrollLeft / frameStep());
    if (moved && Math.abs(dx) > 40) i = dx < 0 ? Math.ceil((framesEl.scrollLeft - 1) / frameStep()) : Math.floor((framesEl.scrollLeft + 1) / frameStep());
    goTo(i);
  }
  framesEl.addEventListener('pointerup', endDrag);
  framesEl.addEventListener('pointercancel', endDrag);
  framesEl.addEventListener('pointerleave', function(e){ if (drag) endDrag(e); });
  framesEl.addEventListener('click', function(e){ if (framesEl.classList.contains('dragging')) e.preventDefault(); }, true);

  /* monogram preview */
  var mi = $('#frpMonoIn'), mp = $('#frpMono'), stage = $('#frpStage');
  var monoOk = !!(stage.dataset.monoX && stage.dataset.monoY);
  var mobile = innerWidth <= 1000;
  if (mobile && monoOk && frames[0]) frames[0].appendChild(mp);
  /* mono_x / mono_y are percentages of the first photograph itself; map them onto the drawn (object-fit: contain) image box */
  function placeMono(){
    if (!monoOk || !frames[0]) return;
    var img = frames[0].querySelector('img'); if (!img || !img.naturalWidth) return;
    var cs = getComputedStyle(img), pl = parseFloat(cs.paddingLeft)||0, pt = parseFloat(cs.paddingTop)||0, pr = parseFloat(cs.paddingRight)||0, pb = parseFloat(cs.paddingBottom)||0;
    var r = img.getBoundingClientRect(), sr = (mobile ? frames[0] : stage).getBoundingClientRect();
    var bw = r.width - pl - pr, bh = r.height - pt - pb, ir = img.naturalWidth / img.naturalHeight, dw, dh;
    if (frames[0].classList.contains('cover')) { dw = r.width; dh = r.height; pl = 0; pt = 0; }
    else if (bw / bh > ir) { dh = bh; dw = bh * ir; } else { dw = bw; dh = bw / ir; }
    var ox = r.left - sr.left + pl + (bw - dw) / 2, oy = r.top - sr.top + pt + (bh - dh) / 2;
    mp.style.left = (ox + dw * parseFloat(stage.dataset.monoX) / 100) + 'px';
    mp.style.top  = (oy + dh * parseFloat(stage.dataset.monoY) / 100) + 'px';
  }
  function syncMono(){ var on = monoOk && !!(mi && mi.value.length) && cur === 0; if (on) placeMono(); mp.classList.toggle('on', on); }
  addEventListener('resize', function(){ if (mp.classList.contains('on')) placeMono(); });
  if (mi) mi.addEventListener('input', function(){
    var v = mi.value.replace(/[^a-zA-Z]/g,'').toUpperCase().slice(0,3); mi.value = v;
    mp.textContent = v.split('').join(' ');
    if (monoOk && v.length && cur !== 0) goTo(0);
    syncMono();
  });

  /* quantity */
  var q = 1, qv = $('#frpQv'), qi = $('#frpQtyInput');
  $('#frpQp').addEventListener('click', function(){ q = Math.min(9, q+1); qv.textContent = q; qi.value = q; });
  $('#frpQm').addEventListener('click', function(){ q = Math.max(1, q-1); qv.textContent = q; qi.value = q; });

  /* variants */
  var sel = [], optCount = 0;
  $$('.frp-sw[aria-pressed="true"]').forEach(function(b){ sel[+b.dataset.opt] = b.dataset.val; optCount = Math.max(optCount, +b.dataset.opt+1); });
  var atcBtn = $('#frpAtc'), priceEl = $('#frpPrice'), sbOpt = $('#frpSbOpt'), sbPrice = $('#frpSbPrice'), vid = $('#frpVariantId');
  function findVariant(){
    return variants.find(function(v){ for (var k=0;k<optCount;k++){ if (v['option'+(k+1)] !== sel[k]) return false; } return true; });
  }
  function applyVariant(v){
    if (!v) return;
    vid.value = v.id;
    priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '');
    sbPrice.textContent = money(v.price); sbOpt.textContent = v.title === 'Default Title' ? '' : nice(v.title);
    var label = atcBtn.querySelector('.add-to-cart-text__content span span');
    if (v.available) { atcBtn.disabled = false; if (label) label.textContent = root.dataset.tAdd; }
    else { atcBtn.disabled = true; if (label) label.textContent = root.dataset.tSoldOut; }
    var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    if (v.featured_media) { var idx = media.findIndex(function(m){ return m.id === v.featured_media.id; }); if (idx > -1) show(idx, 'user'); }
    $$('.frp-sw').forEach(function(b){
      var k = +b.dataset.opt, probe = sel.slice(); probe[k] = b.dataset.val;
      var ok = variants.some(function(x){ for (var j=0;j<optCount;j++){ if (x['option'+(j+1)] !== probe[j]) return false; } return x.available; });
      if (ok) b.removeAttribute('data-unavailable'); else b.setAttribute('data-unavailable','');
    });
  }
  $$('.frp-sw').forEach(function(b){
    b.addEventListener('click', function(){
      var k = +b.dataset.opt; sel[k] = b.dataset.val;
      $$('.frp-sw[data-opt="'+k+'"]').forEach(function(o){ o.setAttribute('aria-pressed','false'); });
      b.setAttribute('aria-pressed','true');
      var lab = $('[data-opt-val="'+k+'"]'); if (lab) lab.textContent = nice(b.dataset.val);
      applyVariant(findVariant());
    });
  });
  if (optCount) applyVariant(findVariant());

  /* what it holds */
  var shapes = $$('.frp-fit');
  function focusFit(k){ shapes.forEach(function(s){ s.style.opacity = (k === null || s.dataset.f === k) ? '1' : '.2'; }); }
  $$('#frpHoldsList li').forEach(function(li){
    li.addEventListener('mouseenter', function(){ focusFit(li.dataset.f); });
    li.addEventListener('mouseleave', function(){ focusFit(null); });
  });

  /* sticky bar */
  var sbar = $('#frpSbar');
  if (atcBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(e){
      var on = !e[0].isIntersecting && (e[0].boundingClientRect.top < 0 || (innerWidth <= 1000 && scrollY > 120));
      sbar.classList.toggle('on', on); if (on) sbar.removeAttribute('inert'); else sbar.setAttribute('inert','');
    }, {threshold:0}).observe(atcBtn);
  }
  $('#frpSbBtn').addEventListener('click', function(){ atcBtn.click(); });

  /* buy it now: add the current selection, then go straight to checkout */
  var buyNow = $('#frpBuyNow');
  if (buyNow) buyNow.addEventListener('click', function(){
    var form = atcBtn.closest('form'); if (!form) return;
    var fd = new FormData(form), busy = buyNow.textContent;
    buyNow.disabled = true; buyNow.textContent = '…';
    fetch('/cart/add.js', {method:'POST', body: fd, headers:{'Accept':'application/json'}})
      .then(function(r){ if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){ location.href = buyNow.dataset.checkout || '/checkout'; })
      .catch(function(){ buyNow.disabled = false; buyNow.textContent = busy; atcBtn.click(); });
  });

  /* lightbox — moved out to <body> so it stays usable while <main> is inert behind it */
  var lb = $('#frpLb'), lbImg = $('#frpLbImg'), lbCap = $('#frpLbCap'), lbShell = $('#frpLbShell'), lbClose = $('#frpLbClose'), lbPrev = $('#frpLbPrev'), lbNext = $('#frpLbNext'), li = 0, lastFocus = null;
  document.body.appendChild(lb);
  var behind = [document.querySelector('main'), document.querySelector('header'), sbar].filter(Boolean);
  function paint(i){
    li = (i + media.length) % media.length;
    lbImg.src = media[li].src; lbImg.alt = frames[li] ? frames[li].dataset.cap : '';
    lbCap.textContent = ('0'+(li+1)).slice(-2) + ' / ' + ('0'+media.length).slice(-2);
    lbImg.classList.remove('zoomed'); lbImg.style.transform = '';
  }
  function openLb(i){ lastFocus = document.activeElement; paint(i); lb.classList.add('on'); document.body.style.overflow='hidden'; behind.forEach(function(n){ n.setAttribute('inert',''); }); lbClose.focus(); }
  function closeLb(){ lb.classList.remove('on'); document.body.style.overflow=''; behind.forEach(function(n){ if (n !== sbar || sbar.classList.contains('on')) n.removeAttribute('inert'); }); if (lastFocus) lastFocus.focus(); }
  $('#frpZoom').addEventListener('click', function(){ openLb(cur); });
  lbClose.addEventListener('click', closeLb);
  lbPrev.addEventListener('click', function(){ paint(li-1); });
  lbNext.addEventListener('click', function(){ paint(li+1); });
  lb.addEventListener('click', function(e){ if (e.target === lb || e.target === lbShell) closeLb(); });
  lbImg.addEventListener('click', function(e){ e.stopPropagation(); if (matchMedia('(hover: none)').matches) return; lbImg.classList.toggle('zoomed'); if (!lbImg.classList.contains('zoomed')) lbImg.style.transform=''; });
  lbShell.addEventListener('mousemove', function(e){
    if (!lbImg.classList.contains('zoomed')) return;
    var r = lbShell.getBoundingClientRect(), x = (e.clientX - r.left)/r.width - .5, y = (e.clientY - r.top)/r.height - .5;
    lbImg.style.transform = 'translate(' + (-x*34) + '%,' + (-y*34) + '%)';
  });
  /* swipe between photos */
  var tx = null, ty = null;
  lb.addEventListener('touchstart', function(e){ if (e.touches.length !== 1) { tx = null; return; } tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, {passive:true});
  lb.addEventListener('touchend', function(e){
    if (tx === null) return;
    var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty; tx = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) paint(dx < 0 ? li+1 : li-1);
  }, {passive:true});
  lb.addEventListener('keydown', function(e){
    if (e.key !== 'Tab') return;
    var f = $$('button', lb), first = f[0], last = f[f.length-1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  addEventListener('keydown', function(e){
    if (!lb.classList.contains('on')) return;
    if (e.key === 'Escape') closeLb(); if (e.key === 'ArrowRight') paint(li+1); if (e.key === 'ArrowLeft') paint(li-1);
  });

  if (window.frReveal) window.frReveal(root);
}
function boot(scope){ Array.prototype.slice.call((scope||document).querySelectorAll('.frp[data-section-id]')).forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ boot(); }); else boot();
document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();
